import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { FlightSteps } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  useFlightShopBreadcrumbs,
  type FlightShopBreadcrumbsComponentProps,
} from "@tenant/flights";
import clsx from "clsx";
import styles from "./styles.module.scss";

type StepStatus = "completed" | "pending" | "selected";

const getStatus = (
  shopStep: FlightSteps,
  currentStep: FlightSteps
): StepStatus => {
  const stepStatusMap = {
    [FlightSteps.DEPARTURE]: 0,
    [FlightSteps.RETURN]: 1,
    [FlightSteps.REVIEW]: 2,
    [FlightSteps.REVIEW_FARE]: 3,
  };

  return stepStatusMap[currentStep] > stepStatusMap[shopStep]
    ? "completed"
    : stepStatusMap[currentStep] < stepStatusMap[shopStep]
      ? "pending"
      : "selected";
};

export const FlightShopBreadcrumbs = ({
  currentStep: currentStepId,
  className,
}: FlightShopBreadcrumbsComponentProps) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(
    styles,
    CoreFlightsComponent.FlightShopBreadcrumbs
  );

  const { shopSteps } = useFlightShopBreadcrumbs({ currentStepId });

  return (
    <div className={clsx(block, className)} id="breadcrumbs">
      <div className={cn("container")}>
        {shopSteps?.map((showStep) => {
          const { step, label, onClick } = showStep;
          const status = getStatus(step as FlightSteps, currentStepId);

          return (
            <div
              key={label}
              className={cn("step", { [status]: true })}
              onClick={onClick}
            >
              <p className="title">{label}</p>
              <p className="subtitle">
                {t(`flightShopProgress.status_${status}`)}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
